import { render, staticRenderFns } from "./TiDicionarioSenior.vue?vue&type=template&id=185eb7b8"
import script from "./TiDicionarioSenior.vue?vue&type=script&lang=js"
export * from "./TiDicionarioSenior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports